
import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import ExportDialog, { ExportType } from './ExportDialog';
import { useLanguage } from '@/hooks/useLanguage';

interface ExportDropdownProps {
  userEmail: string;
}

const ExportDropdown: React.FC<ExportDropdownProps> = ({ userEmail }) => {
  const { translate } = useLanguage();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [exportType, setExportType] = useState<ExportType>('subscriptions');

  const handleExportClick = (type: ExportType) => {
    setExportType(type);
    setDialogOpen(true);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon">
            <Download className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => handleExportClick('subscriptions')}>
            {translate('export.subscriptions.menuItem')}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => handleExportClick('subscription-services')}>
            {translate('export.subscriptionServices.menuItem')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ExportDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        exportType={exportType}
        defaultEmail={userEmail}
      />
    </>
  );
};

export default ExportDropdown;
